module.exports = __webpack_public_path__ + "static/media/bread-crum.fd288c23.svg";